import { render, staticRenderFns } from "./videoSlider.vue?vue&type=template&id=584174b0&scoped=true"
import script from "./videoSlider.vue?vue&type=script&lang=js"
export * from "./videoSlider.vue?vue&type=script&lang=js"
import style0 from "./videoSlider.vue?vue&type=style&index=0&id=584174b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584174b0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Slider: require('/home/forge/meidenvanholland.nl/components/slider.vue').default})
